import { FormInstance } from "antd/es/form";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMasrafCesidi_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMasrafCesidi_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  SelectMasrafCesidi: any[];
  SelectMasrafCesidi_dummy: any[];
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  SaveRecord_2: number;
  SaveRecord_2_dummy: number;
  isCompmasrafcesidi_form_462676AuthorizationVisible: "visible" | "hidden";
}

export class MasrafCesidi_Form_ScreenBase extends React.PureComponent<
  IMasrafCesidi_Form_ScreenProps,
  any
> {
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "27ccb271-a1c3-4fb4-8faf-72f5087446d1",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Masraf Çeşidi Formu" },
        { Id: 462676, PropertyName: "label", Value: "Tarihçe" },
        { Id: 1382840, PropertyName: "value", Value: "Kod" },
        { Id: 6298891, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 7203538, PropertyName: "value", Value: "Ad" },
        { Id: 2054166, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 9544, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.masrafcesidi_form_6298891_value_kuikaTextInputRef = React.createRef();
    this.masrafcesidi_form_2054166_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      GoBack: "",
      SelectMasrafCesidi: [],
      SaveRecord_1: 0,
      SaveRecord_2: 0,
      isCompmasrafcesidi_form_462676AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("masrafcesidi_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MasrafCesidi_FormPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompmasrafcesidi_form_462676AuthorizationVisible",
      [
        "41b245b2-8248-872c-382e-02ee2ce9c846",
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "FLYPILOT",
        "FLYADMIN",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("masrafcesidi_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("masrafcesidi_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MasrafCesidi_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      masrafcesidi_form_6298891_value:
        this.state.SelectMasrafCesidi?.at?.(0)?.kod ?? undefined,
      masrafcesidi_form_2054166_value:
        this.state.SelectMasrafCesidi?.at?.(0)?.ad ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MasrafCesidi_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafCesidi_Form/MasrafCesidi_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectMasrafCesidi = result?.data.selectMasrafCesidi;
    formVars.masrafcesidi_form_6298891_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafCesidi !== undefined
        ? stateVars.SelectMasrafCesidi?.length > 0
          ? stateVars.SelectMasrafCesidi[0].kod
          : null
        : this.state.SelectMasrafCesidi?.length > 0
        ? this.state.SelectMasrafCesidi[0].kod
        : null
    );
    formVars.masrafcesidi_form_2054166_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafCesidi !== undefined
        ? stateVars.SelectMasrafCesidi?.length > 0
          ? stateVars.SelectMasrafCesidi[0].ad
          : null
        : this.state.SelectMasrafCesidi?.length > 0
        ? this.state.SelectMasrafCesidi[0].ad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafCesidi_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafCesidi_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.masrafcesidi_form_6298891_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafCesidi !== undefined
        ? stateVars.SelectMasrafCesidi?.length > 0
          ? stateVars.SelectMasrafCesidi[0].kod
          : null
        : this.state.SelectMasrafCesidi?.length > 0
        ? this.state.SelectMasrafCesidi[0].kod
        : null
    );

    formVars.masrafcesidi_form_2054166_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafCesidi !== undefined
        ? stateVars.SelectMasrafCesidi?.length > 0
          ? stateVars.SelectMasrafCesidi[0].ad
          : null
        : this.state.SelectMasrafCesidi?.length > 0
        ? this.state.SelectMasrafCesidi[0].ad
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MasrafCesidi_FormComponent_462676_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterTablo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Fly.MasrafCesidi", "string"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Ekleyen",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectMasrafCesidi !== undefined
            ? stateVars.SelectMasrafCesidi?.length > 0
              ? stateVars.SelectMasrafCesidi[0].ekleyen
              : null
            : this.state.SelectMasrafCesidi?.length > 0
            ? this.state.SelectMasrafCesidi[0].ekleyen
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Degistiren",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectMasrafCesidi !== undefined
            ? stateVars.SelectMasrafCesidi?.length > 0
              ? stateVars.SelectMasrafCesidi[0].degistiren
              : null
            : this.state.SelectMasrafCesidi?.length > 0
            ? this.state.SelectMasrafCesidi[0].degistiren
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "EklemeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafCesidi !== undefined
            ? stateVars.SelectMasrafCesidi?.length > 0
              ? stateVars.SelectMasrafCesidi[0].eklemeZamani
              : null
            : this.state.SelectMasrafCesidi?.length > 0
            ? this.state.SelectMasrafCesidi[0].eklemeZamani
            : null
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "DegistitirmeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafCesidi !== undefined
            ? stateVars.SelectMasrafCesidi?.length > 0
              ? stateVars.SelectMasrafCesidi[0].degistirmeZamani
              : null
            : this.state.SelectMasrafCesidi?.length > 0
            ? this.state.SelectMasrafCesidi[0].degistirmeZamani
            : null
        ),
        "Date"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MasrafCesidi_Form",
      "TarihceList",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "87753",
      null,
      "right",
      "False",
      "100vw",
      "100vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafCesidi_FormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafCesidi_FormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Ad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafcesidi_form_2054166_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Kod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafcesidi_form_6298891_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EklemeZamani_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Ekleyen_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      DegistirmeZamani_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Degistiren_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafCesidi !== undefined
            ? stateVars.SelectMasrafCesidi?.length > 0
              ? stateVars.SelectMasrafCesidi[0].id
              : null
            : this.state.SelectMasrafCesidi?.length > 0
            ? this.state.SelectMasrafCesidi[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MasrafCesidi_Form/MasrafCesidi_FormComponent_9544_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SaveRecord_1 = result?.data.saveRecord_1;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MasrafCesidi_FormComponent_9544_onClick1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MasrafCesidi_FormComponent_9544_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafCesidi_FormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Ad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafcesidi_form_2054166_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Kod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafcesidi_form_6298891_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      DegistirmeZamani_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Degistiren_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      Id_0_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafCesidi !== undefined
            ? stateVars.SelectMasrafCesidi?.length > 0
              ? stateVars.SelectMasrafCesidi[0].id
              : null
            : this.state.SelectMasrafCesidi?.length > 0
            ? this.state.SelectMasrafCesidi[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MasrafCesidi_Form/MasrafCesidi_FormComponent_9544_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SaveRecord_2 = result?.data.saveRecord_2;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MasrafCesidi_FormComponent_9544_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MasrafCesidi_FormComponent_9544_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafCesidi_FormComponent_9544_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MasrafCesidi_FormPageInit();
    }
  }
}
